import React from 'react';

import ProcurementDashboard from '../procurement_dashboard/ProcurementDashboard';

const ProcurementDashboardTab = () => {
    return <ProcurementDashboard />;
};

export default ProcurementDashboardTab;
